import { apiFetch, readJson } from './client';

export interface FileReviewMentionsOverview {
  rulesSummary: string;
  hubAllowlist: {
    groupObjectId: string;
    displayName?: string | null;
    memberCount: number;
    lastSyncedAt?: string | null;
  }[];
  mentionContactRoster?: {
    activeCount: number;
    sampleEmails: string[];
  } | null;
  syncHealth: {
    jobName: string;
    lastRunAt?: string | null;
    lastStatus?: string | null;
  }[];
  mounts: {
    mountId: string;
    site: string;
    displayName: string;
    entraTenantId?: string | null;
    fileReviewStorageKey?: string | null;
    mentionsEnabled: boolean;
    hubMentionableCount: number;
    clientMentionableCount: number;
    acl: { role: string; groupObjectId?: string | null; groupDisplayName?: string | null; accessMode: string }[];
  }[];
}

export async function fetchFileReviewMentionsOverview(): Promise<FileReviewMentionsOverview> {
  const res = await apiFetch('/api/admin/file-review-mentions/overview');
  if (!res.ok) throw new Error(`Overview failed (${res.status})`);
  return readJson<FileReviewMentionsOverview>(res);
}
